module.exports = __webpack_public_path__ + "static/media/things-change.1432a4ff.png";